import React, { useState } from "react";
import LoadingCircle from "../../../../LoadingCircle";

interface SuggestResultFormProps {
  matchId: number;
  homeTeamName: string;
  guestTeamName: string;
  onSubmit: (scoreHome: number, scoreGuest: number) => Promise<void>;
}

const SuggestResultForm: React.FC<SuggestResultFormProps> = ({
  matchId,
  homeTeamName,
  guestTeamName,
  onSubmit,
}) => {
  const [scoreHome, setScoreHome] = useState<number | null>(null);
  const [scoreGuest, setScoreGuest] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (scoreHome === null || scoreGuest === null) return;
    setLoading(true);
    await onSubmit(scoreHome, scoreGuest);
    setLoading(false);
    setScoreHome(null);
    setScoreGuest(null);
  };

  return (
    <form onSubmit={handleSubmit} className="rounded-xl w-full">
      <h2 className="font-semibold mt-2">Suggest Result</h2>
      <div className="flex flex-wrap gap-3 items-end">
        <div>
          <label className="block">{homeTeamName}</label>
          <input
            type="number"
            className="w-20 px-3 py-2 border rounded-xl text-black"
            value={scoreHome !== null ? scoreHome : ""}
            onChange={(e) => {
              const value = e.target.value;
              setScoreHome(value === "" ? null : parseInt(value));
            }}
            required
          />
        </div>
        <div>
          <label className="block">{guestTeamName}</label>
          <input
            type="number"
            className="w-20 px-3 py-2 border rounded-xl text-black"
            value={scoreGuest !== null ? scoreGuest : ""}
            onChange={(e) => {
              const value = e.target.value;
              setScoreGuest(value === "" ? null : parseInt(value));
            }}
            required
          />
        </div>
        <div className="grow" />
        <button
          type="submit"
          className={`min-w-48 py-2 h-10 font-semibold text-white bg-blue-500 rounded-xl hover:bg-blue-600 ${
            loading ? "hover:bg-blue-500" : ""
          }`}
          disabled={loading}
        >
          {loading ? <LoadingCircle small={true} /> : <p>Suggest Result</p>}
        </button>
      </div>
    </form>
  );
};
export default SuggestResultForm;
